module.exports = __webpack_public_path__ + "img/icon_btm_jr3.cdfd9c69.png";